import BaseModel, {defineTranslatableProperties} from "../../../../core/components/input-widget/BaseModel";

export default class CollectionModel extends BaseModel {
  uuid = null;

  static TRANSLATABLE_FIELDS = [];

  attributeHints = {}

  rules = {};

  attributeLabels = {};

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});

    this.initTranslatableFields(this)
    this.initDynamicFields(this, {
      "title": {
        "type": "text",
        "label": "Title",
        "rules": {
          "required": true,
          "allow_null": false,
          "allow_blank": false
        },
        "position": 1,
        "field_class_name": "CharField"
      }
    });
  }


  toJSON() {
    let data = super.toJSON();
    return data;
  }
}

defineTranslatableProperties(CollectionModel);
